export function initChat(api) {
  var root = document.getElementById('chatw');
  if (!root) return;

  var panel = document.getElementById('chatwPanel');
  var fab = document.getElementById('chatwFab');
  var fabLabel = document.getElementById('chatwFabLabel');
  var badge = document.getElementById('chatwBadge');
  var closeBtn = document.getElementById('chatwClose');
  var log = document.getElementById('chatwLog');
  var quick = document.getElementById('chatwQuick');
  var form = document.getElementById('chatwForm');
  var input = document.getElementById('chatwText');
  var bar = document.getElementById('chatwBar');

  var CLOSED_KEY = 'rost_chat_closed';
  var TOTAL = 4;
  var mqMobile = window.matchMedia('(max-width: 767px)');

  var T = {
    greet1: 'Вітаю! Я Андрій К., помічник адвоката. Допоможу коротко описати ваше питання, щоб адвокат підготувався до розмови.',
    topicQ: 'В якому питанні ви потребуєте допомоги? Напишіть своїми словами.',
    topicBad: 'Напишіть, будь ласка, кількома словами, з яким питанням звертаєтесь.',
    problemQ: 'Опишіть ситуацію двома-трьома реченнями — адвокат одразу розумітиме контекст.',
    nameQ: 'Як до вас звертатися?',
    nameBad: 'Напишіть, будь ласка, ваше імʼя або натисніть «Пропустити».',
    phoneQ: function (n) { return (n ? n + ', залиште' : 'Залиште') + ' номер телефону — адвокат передзвонить вам.'; },
    phoneBad: 'Схоже, у номері помилка. Вкажіть номер у форматі +380 XX XXX XX XX.',
    noted: 'Записав 👌',
    summary: function (d) {
      var rows = ['✓ Питання: ' + d.topic];
      if (d.problem) rows.push('✓ Опис: ' + (d.problem.length > 140 ? d.problem.slice(0, 140).trim() + '…' : d.problem));
      if (d.name) rows.push('✓ Імʼя: ' + d.name);
      rows.push('✓ Телефон: ' + d.phone);
      return 'Формую заявку:\n' + rows.join('\n');
    },
    sending: 'Надсилаю заявку адвокату…',
    done: function (n) {
      return 'Дякую' + (n ? ', ' + n : '') + '! Заявку передано адвокату — він звʼяжеться з вами найближчим часом.';
    },
    fail: 'Не вдалося надіслати заявку. Спробуйте ще раз або зателефонуйте нам.',
    retry: 'Надіслати ще раз',
    skip: 'Пропустити',
    phTopic: 'Наприклад: відстрочка, ВЛК, СЗЧ…',
    phProblem: 'Коротко опишіть ситуацію…',
    phName: 'Ваше імʼя',
    phPhone: '+380 __ ___ __ __',
    fabIdle: 'Опишіть проблему',
    fabGo: 'Продовжити розмову',
    fabDone: 'Заявку надіслано'
  };

  var state = { step: 'topic', open: false, busy: false, started: false, sent: false, engaged: false, data: {}, done: 0 };

  function now() {
    var d = new Date();
    return ('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2);
  }

  function scrollLog() { log.scrollTop = log.scrollHeight; }

  function bubble(who, text) {
    var el = document.createElement('div');
    el.className = 'chatw-msg chatw-msg--' + who;
    var body = document.createElement('div');
    body.className = 'chatw-msg__text';
    body.textContent = text;
    var time = document.createElement('time');
    time.className = 'chatw-msg__time';
    time.textContent = now();
    el.appendChild(body);
    el.appendChild(time);
    log.appendChild(el);
    scrollLog();
    return el;
  }

  function typing() {
    var el = document.createElement('div');
    el.className = 'chatw-msg chatw-msg--bot chatw-typing';
    el.innerHTML = '<span></span><span></span><span></span>';
    log.appendChild(el);
    scrollLog();
    return el;
  }

  function bot(texts, after) {
    texts = [].concat(texts);
    state.busy = true;
    setInputEnabled(false);
    var i = 0;
    (function next() {
      if (i >= texts.length) {
        state.busy = false;
        setInputEnabled(!state.sent);
        if (!state.open) showBadge(true);
        if (after) after();
        return;
      }
      var t = typing();
      var text = texts[i++];
      setTimeout(function () {
        t.remove();
        bubble('bot', text);
        next();
      }, Math.min(1400, 450 + text.length * 8));
    })();
  }

  function setQuick(options) {
    quick.innerHTML = '';
    (options || []).forEach(function (o) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'chatw-chip';
      b.textContent = o.label;
      b.addEventListener('click', function () {
        if (state.busy) return;
        o.onClick();
      });
      quick.appendChild(b);
    });
    quick.hidden = !quick.children.length;
    scrollLog();
  }

  function setInputEnabled(on) {
    input.disabled = !on;
    form.classList.toggle('is-off', !on);
    if (on && state.open && state.engaged && !mqMobile.matches) input.focus({ preventScroll: true });
  }

  function setMode(step) {
    var tel = step === 'phone';
    input.setAttribute('inputmode', tel ? 'tel' : 'text');
    input.setAttribute('autocomplete', tel ? 'tel' : (step === 'name' ? 'given-name' : 'off'));
    input.placeholder = { topic: T.phTopic, problem: T.phProblem, name: T.phName, phone: T.phPhone }[step] || '';
    input.value = '';
    autosize();
  }

  function progress() {
    state.done += 1;
    if (bar) bar.style.width = Math.min(100, Math.round(state.done / TOTAL * 100)) + '%';
  }

  function hasLetters(v) { return /[a-zA-Zа-яА-ЯіїєґІЇЄҐёЁ]/.test(v); }

  function normPhone(raw) {
    var v = String(raw || '').trim();
    var plus = /^\+/.test(v);
    var d = (v.match(/\d/g) || []).join('');
    if (/^3800\d{9}$/.test(d)) d = '380' + d.slice(4);
    if (/^0\d{9}$/.test(d)) d = '380' + d.slice(1);
    if (!plus && /^\d{9}$/.test(d)) d = '380' + d;
    if (/^380\d{9}$/.test(d)) {
      return {
        pretty: '+380 ' + d.slice(3, 5) + ' ' + d.slice(5, 8) + ' ' + d.slice(8, 10) + ' ' + d.slice(10, 12),
        country: 'UA'
      };
    }
    if (plus && d.length >= 10 && d.length <= 15 && !/^380/.test(d)) {
      return { pretty: '+' + d, country: '' };
    }
    return null;
  }

  function ask(step) {
    state.step = step;
    setMode(step);
    if (step === 'topic') {
      setQuick([]);
      bot(T.topicQ);
    } else if (step === 'problem') {
      bot(T.problemQ, function () { setQuick([{ label: T.skip, onClick: function () { answer(''); } }]); });
    } else if (step === 'name') {
      bot(T.nameQ, function () { setQuick([{ label: T.skip, onClick: function () { answer(''); } }]); });
    } else if (step === 'phone') {
      setQuick([]);
      bot(T.phoneQ(state.data.name));
    }
  }

  function answer(raw) {
    var text = String(raw || '').replace(/\s+$/, '').replace(/^\s+/, '');
    var step = state.step;
    setQuick([]);

    if (!state.started) {
      state.started = true;
      if (window.dataLayer) window.dataLayer.push({ event: 'chat_start' });
    }

    if (step === 'topic') {
      if (text) bubble('user', text);
      if (text.length < 3 || !hasLetters(text)) { bot(T.topicBad); return; }
      state.data.topic = text.slice(0, 300);
      progress();
      ask('problem');
      return;
    }

    if (step === 'problem') {
      bubble('user', text || T.skip);
      state.data.problem = text.slice(0, 3000);
      progress();
      if (text) { state.step = 'name'; setMode('name'); bot([T.noted, T.nameQ], function () { setQuick([{ label: T.skip, onClick: function () { answer(''); } }]); }); }
      else ask('name');
      return;
    }

    if (step === 'name') {
      bubble('user', text || T.skip);
      if (text && (!hasLetters(text) || text.length > 60)) {
        bot(T.nameBad, function () { setQuick([{ label: T.skip, onClick: function () { answer(''); } }]); });
        return;
      }
      state.data.name = text;
      progress();
      ask('phone');
      return;
    }

    if (step === 'phone') {
      if (text) bubble('user', text);
      var p = normPhone(text);
      if (!p) { bot(T.phoneBad); return; }
      state.data.phone = p.pretty;
      state.data.country = p.country;
      progress();
      submit();
    }
  }

  function submit() {
    state.step = 'sending';
    state.sent = true;
    setInputEnabled(false);
    bot([T.summary(state.data), T.sending], function () {
      state.busy = true;
      api.getRecaptchaToken().then(function (token) {
        return api.verifyRecaptcha(token).then(function (ok) {
          if (!ok) throw new Error('recaptcha_failed');

          var leadRef = 'L-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 7);
          try { sessionStorage.setItem('rost_lead_ref', leadRef); } catch (e) { }

          api.sendLead({
            lead_ref: leadRef,
            source: 'chat',
            customer_name: state.data.name || '',
            phone: state.data.phone,
            country_code: state.data.country || '',
            topics: [state.data.topic],
            problem: state.data.problem || '',
            consent: true,
            direction: api.keyword || state.data.topic,
            direction_source: api.keyword ? 'utm_term' : 'topics',
            keyword: api.keyword,
            utm: api.utm,
            referer: document.referrer || '',
            page: location.href,
            spam: false,
            recaptcha_token: token || '',
            ts: new Date().toISOString()
          }, function () {
            if (fabLabel) fabLabel.textContent = T.fabDone;
            bot(T.done(state.data.name), function () {
              state.busy = true;
              setTimeout(api.goThanks, 1600);
            });
          });
        });
      }).catch(function () {
        state.busy = false;
        state.sent = false;
        state.step = 'phone';
        bot(T.fail, function () {
          setInputEnabled(false);
          setQuick([{ label: T.retry, onClick: function () { setQuick([]); submit(); } }]);
        });
      });
    });
  }

  function autosize() {
    input.style.height = 'auto';
    input.style.height = Math.min(input.scrollHeight, 120) + 'px';
  }

  function showBadge(on) { if (badge) badge.hidden = !on; }

  function syncViewport() {
    var vv = window.visualViewport;
    if (!vv) return;
    var kb = Math.max(0, Math.round(window.innerHeight - vv.height - vv.offsetTop));
    root.style.setProperty('--chatw-kb', kb + 'px');
    root.style.setProperty('--chatw-vvh', Math.round(vv.height) + 'px');
  }

  var booted = false;
  function boot() {
    if (booted) return;
    booted = true;
    bot(T.greet1, function () { ask('topic'); });
  }

  function open(byUser) {
    if (state.open) return;
    state.open = true;
    panel.hidden = false;
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    fab.setAttribute('aria-expanded', 'true');
    showBadge(false);
    syncViewport();
    boot();
    if (byUser) {
      state.engaged = true;
      try { sessionStorage.removeItem(CLOSED_KEY); } catch (e) { }
      if (!mqMobile.matches && !input.disabled) setTimeout(function () { input.focus({ preventScroll: true }); }, 250);
      if (window.dataLayer) window.dataLayer.push({ event: 'chat_open' });
    }
    scrollLog();
  }

  function close() {
    if (!state.open) return;
    state.open = false;
    root.classList.remove('is-open');
    fab.setAttribute('aria-expanded', 'false');
    if (fabLabel && !state.sent) fabLabel.textContent = state.started ? T.fabGo : T.fabIdle;
    try { sessionStorage.setItem(CLOSED_KEY, '1'); } catch (e) { }
    setTimeout(function () { if (!state.open) panel.hidden = true; }, 250);
    input.blur();
  }

  fab.addEventListener('click', function () { open(true); });
  panel.addEventListener('pointerdown', function () { state.engaged = true; });
  closeBtn.addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && state.open) close(); });
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-chat-open]');
    if (!opener) return;
    e.preventDefault();
    open(true);
  });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', syncViewport);
    window.visualViewport.addEventListener('scroll', syncViewport);
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (state.busy || state.sent || input.disabled) return;
    var v = input.value;
    if (!v.trim()) { input.focus(); return; }
    input.value = '';
    autosize();
    answer(v);
  });

  input.addEventListener('input', autosize);
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey && !e.isComposing) {
      e.preventDefault();
      form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true }));
    }
  });

  var wasClosed = false;
  try { wasClosed = sessionStorage.getItem(CLOSED_KEY) === '1'; } catch (e) { }
  if (wasClosed) {
    showBadge(true);
  } else {
    setTimeout(function () { open(false); }, 1200);
  }
}
